import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "person"]

  open(event) {
    event.preventDefault()
    const annotations = this.application.getControllerForElementAndIdentifier(this.element, "photo-annotations")
    const identified = new Set((annotations?.items || []).map(item => this.normalize(item.name)))
    this.personTargets.forEach(person => {
      const name = person.dataset.name
      const matched = identified.has(this.normalize(name)) || identified.has(this.normalize(name.replace(/\([^)]*\)/g, "")))
      person.querySelector(".photo-directory-identified").hidden = !matched
      person.classList.toggle("is-identified", matched)
    })
    this.dialogTarget.showModal()
  }

  normalize(name) {
    return name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
      .replace(/ß/g, "ss").replace(/\s+/g, " ").trim()
  }

  disconnect() {
    this.dialogTarget.close()
  }
}
